/// <amd-module name="Reporting/BoardsCommon/ResetElement" />
import * as React from "react";
import * as Resources from "Reporting/BoardsCommon/Resources";

import { Button } from "VSSUI/Button";

export interface ResetElementProps {
    onClick: () => void;
    isEnabled?: boolean;
}
/** Provides a common reset UI for use in Boards reports. Comes labelled in a FormItem. */
export class ResetElement extends React.Component<ResetElementProps> {
    public render() {
        return (
            <Button
                className="reset-settings-button subtle"
                ariaLabel={Resources.ResetButtonDetail}
                onClick={this.props.onClick}
                text={Resources.ResetLabel}
                disabled={!this.props.isEnabled}
                tooltipProps={{ text: Resources.ResetButtonDetail }}
            />
        );
    }
}
